<template>
<div>
  <v-text-field
    v-mask="maskCheck()"
    @input="handleVisitorDocument"
    :label="$t('appointment.formCreate.labels.visitorDocument')"
    :rules="rulesCheck()"
    hide-details="auto"
    outlined
  />
</div>
</template>

<script>
import { cpfCnpj } from '@/util/masks'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'VisitorDocument',

  props: {
    rules: {
      type: Array,
    },

    country: {
      type: String,
      required: false,
      default: 'BR',
    },
  },

  computed: {
    ...mapGetters(['appointmentFields']),

    document() {
      return this.appointmentFields.visitor_document
    }
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    maskCheck() {
      if (this.country === 'BR') {
        if (!this.value || this.value?.length <= 14) return '###.###.###-##'
        else return '##.###.###/####-##'
      }

      return ''
    },

    rulesCheck() {
      if (!this.rules) return []
      if (this.country === 'BR') return this.rules
      return []
    },

    handleVisitorDocument(document) {
      const cleanedDoc = document?.replace(/[^\d]/g, '')
      this.setAppointmentFields({ visitor_document: cleanedDoc })
    },
  },

  data() {
    return {
      mask: { cpfCnpj },
    }
  }
}
</script>
